import { render } from "./SubCommentButton.vue?vue&type=template&id=11860739&scoped=true"
import script from "./SubCommentButton.vue?vue&type=script&lang=js"
export * from "./SubCommentButton.vue?vue&type=script&lang=js"

import "./SubCommentButton.vue?vue&type=style&index=0&id=11860739&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11860739"]])

export default __exports__